export default "assets/logo-6f5b21fa.svg";